import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCasesService } from "services/ClientPortalCasesService";
import { ClientPortalCaseFiltersModel, ClientPortalCaseModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  Cases: new Array<ClientPortalCaseModel>(),
  Loading: false,
};

export const CasesTableSlice = createSlice({
  name: "CasesTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCases.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCases.fulfilled, (state, action) => {
        state.Cases = action.payload;
        state.Loading = false;
      })
      .addCase(getCases.rejected, (state) => {
        state.Cases = new Array<ClientPortalCaseModel>();
        state.Loading = false;
      });
  },
});

export const getCases = createAsyncThunk<ClientPortalCaseModel[], { caseFilters: ClientPortalCaseFiltersModel }>(
  "CasesTable/GetCases",
  async ({ caseFilters }) => {
    const casesService = container.get<IClientPortalCasesService>(SERVICE_TYPES.ClientPortalCasesService);
    return await casesService.getCases(caseFilters);
  }
);

export const selectCases = (state: RootState) => state.casesTable.Cases;
export const selectLoadingCases = (state: RootState) => state.casesTable.Loading;

export default CasesTableSlice.reducer;
